import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-系统管理_油公司管理",
  "use": "icon-系统管理_油公司管理-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-系统管理_油公司管理\">\n<g>\n\t<path d=\"M15,3.8h-4.4V1.2H1.7v5.9v2.3v5.1h1V8.3V5.8V2.6c0-0.1,0-0.2,0.1-0.3C2.9,2.2,3,2.2,3.1,2.2h6.1c0.1,0,0.2,0,0.3,0.1\n\t\tc0.1,0.1,0.1,0.2,0.1,0.3v9.2v0v2.7h1v-1.1v-1.1V4.8h3c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.1,0.2,0.1,0.3v4.3v1.1v3.9h1v-4.4l0,0V3.8z\" />\n\t<g>\n\t\t<rect x=\"0.2\" y=\"13.8\" width=\"15.7\" height=\"1\" />\n\t</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol